import { useEffect } from 'react';
import ActivityService from '../../../services/activity_service';

const Fetch = (vm) => {
  const fetchActivities = async () => {
    vm.setLoading(true);
    try {
      const pageActivity = await ActivityService.getAll();
      if (vm.logout(pageActivity)) return;
      vm.setActivities(pageActivity || []);
    } catch (e) {
      vm.message(e?.message || e, "error");
    } finally {
      vm.setLoading(false);
    }
  };

  useEffect(() => {fetchActivities()}, []);
};

export default Fetch;
